import get from 'lodash.get';
import getBlockByElement from './get-block-by-element';

const getDisplayOptionsForElement = (blockNode) => {
  const block = getBlockByElement(blockNode);
  if (!block) return [];

  const displayOptions = get(block, 'availableSettings.displayOptions', []);
  const attributes = [...blockNode.attributes];

  return displayOptions
    .map((option) => {
      const { attribute, id, options, type, hidden, index, toggleable } = option;
      const nodeAttribute = attributes.find((attributeItem) => attributeItem.name === attribute);
      let value = nodeAttribute ? nodeAttribute.value : null;

      if (Number.isInteger(index)) {
        const values = value.split(' ');

        value = values[index] || null;
      }

      return {
        id,
        hidden,
        attribute,
        index,
        type,
        toggleable,
        value,
        isSet: !!nodeAttribute,
        options,
      };
    })
    .filter((item) => !!item);
};

export default getDisplayOptionsForElement;
